import { ColumnDataType, Provider } from '../types'
import { EnrichComponent } from './common/enrichcomponent'

class H3Enrich extends EnrichComponent {
  constructor() {
    super(
      {
        name: 'native.h3enrich',
        group: 'Data Enrichment',
        title: 'Enrich H3 Grid',
        description: `
      This component uses a data source (either a table or a DO subscription) to enrich a target H3 table.
      `,
        starred: true
      },
      'ENRICH_GRID',
      'h3'
    )

    // FIXME
    // this.supportedProviders = [Provider.BigQuery, Provider.Snowflake]

    // adapt the input descriptions to the specific command geo type
    let index = this.inputs.findIndex((i) => i.name === 'target')
    this.inputs[index].description = this.inputs[index].title = 'Target H3 table'

    index = this.inputs.findIndex((i) => i.name === 'target_col')
    this.inputs[index].description = this.inputs[index].title = 'Target H3 column'
    this.inputs[index].dataType = [ColumnDataType.String]
  }

  supportedProviders(): Provider[] {
    return [Provider.BigQuery, Provider.Snowflake, Provider.Redshift]
  }
}

export { H3Enrich }
